import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import { BrandDashboard } from '@/components/BrandDashboard';
import { useUser } from '@/contexts/UserContext';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';

const BrandDashboardPage = () => {
  const { accountType } = useUser();
  const { isMobile } = useEnhancedMobile();

  // Page header configuration based on account type
  const title = accountType === 'venture' ? 'Investment Dashboard.' : 'Deal Management.';
  const subtitle = accountType === 'venture' 
    ? 'Manage your portfolio investments, track tasks, and generate term sheets' 
    : 'Upload new deals, generate SOWs, and manage your partnerships';

  return (
    <Layout>
      <PageHeader title={title} subtitle={subtitle} />
      <div className={`container mx-auto max-w-[1200px] overflow-x-hidden ${isMobile ? 'px-2 py-2' : 'px-6 py-6'}`}>
        <BrandDashboard />
      </div>
    </Layout>
  );
};

export default BrandDashboardPage;
